import { Typography, Box } from "@mui/material";

const Subheader = ({ id = "", title }) => {
    return (
        <Box id={id} sx={{ scrollMarginTop: 80 }}>
            <Typography variant="h6" gutterBottom
                sx={theme => ({
                    color: theme.palette.primary.main
                })}>
                {title}
            </Typography>
        </Box>
    );
};

export default Subheader;
